import type { FC } from 'react';
import React from 'react';
import cn from 'classnames';
import { Tooltip } from '@alfa-bank/site-tooltip-v2';
import { NamedContainer } from '@alfa-bank/site-named-container';

import type { IHintProps } from './models';
import styles from './styles.css';

export const HintDesktop: FC<IHintProps> = ({ children, className, content }) => {
    if (!content) {
        return <>{children}</>;
    }

    // TODO: переиспользовать тут hint из invest-ui, отсюда копировал в PDS и расширял, а чуть позже вынес в ui
    // https://jira.moscow.alfaintra.net/browse/SITEMLDIVE-4509
    return (
        <Tooltip
            className={cn(styles.external, styles.hintWrapper, className)}
            popoverClassName={cn(styles.external, styles.popover)}
            position="bottom"
            // нельзя ставить span так как внутри блочные элементы которые ломаются при регидрации из-за @loadable/component
            tag="div"
            targetClassName={cn(styles.external, styles.hint)}
            trigger="click"
            view="tooltip"
        >
            <NamedContainer name="content">{content}</NamedContainer>
            {children}
        </Tooltip>
    );
};
